import type { FeInvI18nKey } from '@w/fe-inv-i18n'

export const i18Key = (key: FeInvI18nKey) => key
